module.exports = "img/rotate-cw.b6a9518.svg";